'use strict';

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function BrandGamefaqsLogoLight(props) {
    return (React__namespace.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", width: "1em", height: "1em" }, props),
        React__namespace.createElement("rect", { width: 18, height: 18, x: 1, y: 1, stroke: "#3D51BF", strokeWidth: 2, rx: 9 }),
        React__namespace.createElement("path", { fill: "#291927", fillOpacity: 0.2, d: "M15.79 5.83H9.106c-.662 0-1.336.535-1.498 1.18l-.185.758h7.838l.53-1.938zm-6 5.567h2.606l-.343 1.386a.327.327 0 01-.3.235h-3.24a.18.18 0 01-.18-.235l1.014-4.098H7.194l-1.33 5.347c-.16.647.25 1.177.919 1.177h5.431c.664 0 1.34-.53 1.5-1.177l1.156-4.55h-4.59l-.49 1.915z" }),
        React__namespace.createElement("path", { fill: "#3D51BF", d: "M14.96 5H8.276c-.662 0-1.336.535-1.498 1.18l-.185.758h7.838L14.96 5zm-6 5.567h2.606l-.343 1.386a.328.328 0 01-.3.235h-3.24a.18.18 0 01-.181-.235l1.015-4.098H6.364l-1.33 5.347c-.16.647.25 1.177.919 1.177h5.431c.664 0 1.34-.53 1.5-1.177l1.156-4.55H9.45l-.49 1.915z" })));
}

module.exports = BrandGamefaqsLogoLight;
